import React from "react";
import AzureAD, {
  IAzureADFunctionProps,
  AuthenticationState
} from "react-aad-msal";
import { AuthProvider } from "../../AuthProvider";
import { store } from "../../.";

const LogoutPage: React.FC = () => {
  return (
    <AzureAD provider={AuthProvider} reduxStore={store.store}>
      {(a: IAzureADFunctionProps) => {
        if (a.authenticationState === AuthenticationState.Unauthenticated)
          return (
            <div>
              <div>
                <p>You are now logout of the Statement of Facts Web App</p>
                <p>
                  Click <a onClick={a.login}>here</a> to login again.
                </p>
              </div>
            </div>
          );
      }}
    </AzureAD>
  );
};

export default LogoutPage;
